export const wideMenuMinWidth = '174px';
export const regularMenuMinWidth = '160px';
export const skinnyMenuMinWidth = '110px';
